// Shared types for the statuspage frontend

export type SupportedLang = 'en' | 'de'

export interface Service {
  id: string
  name: string
  scope: string
  translations?: Record<string, { name?: string }>
}

export interface Component {
  name: string
  service?: string
  translations?: Record<string, { name?: string }>
}

export interface Update {
  at: string
  status: string
  message: string | Record<string, string>
}

export interface Entry {
  id: string
  type: string
  severity: string
  status: string
  service: string
  component?: string
  state?: string // 'draft', 'published', or 'edited'
  title: Record<string, string>
  summary: Record<string, string>
  details?: Record<string, string>
  updates?: Update[]
  start_at: string
  end_at?: string
  published_at?: string
  published_by?: string
}

export interface FilterChip {
  kind: 'type' | 'severity' | 'status' | 'service' | 'component' | 'text'
  value: string
  label: string
}

export interface PublishProgress {
  total_targets: number
  sent_count: number
  failed_count: number
  is_complete: boolean
  error?: string
}

export interface ToastHistoryEntry {
  message: string
  type: string
  timestamp?: string
}

// Status values by event type
export const statusesByType: Record<string, string[]> = {
  incident: ['investigating', 'identified', 'monitoring', 'resolved'],
  maintenance: ['scheduled', 'in_progress', 'completed', 'canceled'],
  info: ['published', 'updated', 'archived'],
}

export const successStatuses = new Set(['resolved', 'completed'])
export const dimmedStatuses = new Set(['resolved', 'completed', 'canceled', 'archived'])
